export default {
  noData: 'No hay más datos disponibles',
  delConfirmTips: '¿Estás seguro de que deseas eliminar los datos seleccionados?',
  delSuccess: 'Eliminado correctamente',
  tips: 'Sugerencias',
  add: 'Agregar',
  edit: 'Editar',
  del: 'Eliminar',
  editSuccess: 'Modificado correctamente',
  activeAccount: 'Activar cuenta',
  mailActiveSuccess: 'Activación de cuenta exitosa',
  back: 'Volver',
  goLogin: 'Ir a iniciar sesión',
  email: 'Correo electrónico',
  emailSendSuccess: 'Correo electrónico enviado correctamente',
  paySuccess: 'Pago exitoso',
  action: 'Acción',
  logoutSuccess: 'Cierre de sesión exitoso',
  plsUpload: 'Por favor, subir',
  upload: 'Subir',
  file: 'Archivo',
  uploadFail: 'Error al subir',
  uploadSuccess: 'Subido correctamente',
  pay: 'Pagar',
  day: 'Día',
  servePrice: 'Tarifa del servicio',
  skillServePrice: 'Tarifa de servicio técnico',
  unitMonth: 'Mes(es)',
  num: 'Cantidad',
  photo: 'Foto',
  product: 'Producto',
  sizeHaveUnit: 'Tamaño (cm)',
  weightHaveUnit: 'Peso (g)',
  fee: 'Tarifa',
  free: 'Gratis',
  submitTime: 'Hora de envío',
  weight: 'Peso',
  cancelReason: 'Razón de cancelación',
  submitPackage: 'Enviar paquete',
  submitSuccess: 'Enviado correctamente',
  price: 'Precio',
  status: 'Estado',
  noProduct: 'No hay productos',
  backEdit: 'Volver a editar',
  errorHint: 'Error de interfaz, por favor intenta de nuevo',
  reload: 'Recargar',
  reloadPageTips:
    'Has cambiado de cuenta. Por favor, recarga la página para obtener información actualizada.',
  cancel: 'Cancelar',
  noMsg: 'Sin información',
  totalAmount: 'Monto total',
  see: 'Ver',
  confirm: 'Confirmar',
  send: 'Enviar',
  nowNoInfo: 'No hay información en este momento',
  genderEnum: {
    0: 'Hombre',
    1: 'Mujer',
  },
  goEmailActiveTips: 'Por favor, ve a tu correo electrónico para activar tu cuenta!',
  holder: {
    inputRemark: 'Por favor, ingresa los comentarios',
    inputExplainCancelReason: 'Por favor, explica la razón de la cancelación',
    inputAddAddress: 'Por favor, agrega la dirección de envío',
    inputMsg: 'Por favor, ingresa el mensaje',
  },
  acceptMsg:
    'Este sitio web almacena cookies en tu computadora para brindarte una mejor experiencia. Consulta tu política de privacidad para obtener más información.',
  accept: 'Aceptar',
  refuse: 'Rechazar',
  notice: 'Aviso',
  noticeMsg: 'Nueva línea logística, 10% de descuento',
  english: 'Inglés',
  spanish: 'Español',
  french: 'Francés',
  chinese: 'Chino',
  copySuccess: 'Copiado correctamente',
  copyError: 'Error al copiar',
  noAgainShow: 'No mostrar de nuevo',
  download: 'Descargar',
  downloadSuccess: 'Descargado correctamente',
  uploadImgTips: 'Por favor, sube archivos JPG/PNG/WEBP/JPEG',
  noCheckAboutAgree: 'No se ha marcado Aceptar el acuerdo',
  country: 'País',
  collectSuccess: '¡Recopilación exitosa!',
  cancelCollectSuccess: '¡Cancelación de recopilación exitosa!',
  formatError: 'Error de formato, por ejemplo, {formatStr}',
  volume: 'Volumen (cm)',
  notRequired: 'No requerido',
  productSaleCount: 'Ventas',
  searchPlaceholder: 'Por favor, ingresa el contenido de búsqueda',
  THEME_MODE: 'Modo temático',
  FOLLOW_SYSTEM: 'Sigue el sistema',
  DAY_MODE: 'Modo día',
  NIGHT_MODE: 'Modo nocturno',
}
